
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1798',
  depVersions: {
  "customer-portal-app": "static-1.1798",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9529",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24870",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5445",
  "hs-test-utils": "static-1.7858",
  "hub-http": "static-1.6070",
  "hub-http-shared-msw-handlers": "static-1.9596",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17742",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11295",
  "I18n": "static-7.1586",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6322",
  "payment-link-components": "static-1.23073",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6802",
  "quartz-core": "static-1.6021",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10063",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5222",
  "rich-text-lib": "static-1.19559",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17734",
  "ui-components-test-utils": "static-1.5433",
  "UIComponents": "static-3.8242",
  "foundations-assets": "static-1.4694",
  "foundations-components": "static-1.7627",
  "foundations-theming": "static-1.4263",
  "foundations-theming-specialty": "static-1.1979",
  "framer-motion": "static-1.68",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.604",
  "quartz-config": "static-1.580",
  "quartz-routing": "static-1.232",
  "quick-fetch": "static-1.3786",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16502",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7997",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.51",
  "ui-addon-draggable": "static-3.4619",
  "ui-addon-react-router-dom": "static-1.9397",
  "usage-tracker": "static-1.7187",
  "usage-tracker-anonymous": "static-1.5604",
  "usage-tracker-core": "static-1.7037",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3278",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3079",
  "quartz-webpack": "static-1.3026",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "customer-data-objects": "static-1.7503",
  "frontend-preferences-client": "static-1.7777",
  "laboratory-lib": "static-3.7011",
  "onboarding-scopes": "static-1.6315",
  "rpc-client-utils": "static-1.4493",
  "ui-addon-opt": "static-4.8235",
  "HeadJS": "static-2.723",
  "hs-test-utils-bend-plugin": "static-1.2969",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3953",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7524",
  "cssUtils": "static-1.751",
  "customer-data-ui-utilities": "static-1.9676",
  "HubStyle": "static-2.11603",
  "knowledge-content-types": "static-1.8410",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.477",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.484",
  "ui-addon-emoji-picker": "static-1.9739",
  "ui-addon-i18n": "static-1.10996",
  "ui-business-units-lib": "static-1.8885",
  "ui-shepherd-react": "static-3.9998",
  "video-components-external": "static-1.10732",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4178",
  "commerce-tours-lib": "static-1.5801",
  "customer-data-properties": "static-1.50935",
  "getting-started-shared-tasks": "static-1.18022",
  "growth-onboarding-reliability": "static-1.4938",
  "onboarding-tours": "static-1.16339",
  "reference-resolvers-lite": "static-1.7937",
  "sales-checkout-service-client": "static-1.3520",
  "ui-addon-iframeable": "static-1.8899",
  "user-context": "static-1.4952",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.808",
  "hubspotter-http": "static-1.4526",
  "icons": "static-2.630",
  "mobile-manifest-mixins": "static-1.498",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.477",
  "quartz-head": "static-1.467",
  "quartz-test": "static-1.477",
  "quartz-tracking": "static-1.181",
  "ui-fonts": "static-1.557",
  "usage-tracker-container": "static-1.7177",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9278",
  "data-token-picker": "static-1.16131",
  "FileManagerLib": "static-1.38693",
  "property-translator": "static-1.5262",
  "atom": "static-1.4922",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5560",
  "salesImages": "static-1.521",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.5110",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1111",
  "bend-plugin-foundations-components": "static-1.3896",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "trellis-assets": "static-1.1356",
  "bend-plugin-foundations-theming": "static-1.2746",
  "foundations-theming-base": "static-1.3248",
  "stylex": "static-1.28",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5601",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4326",
  "react-flip-move": "static-1.66",
  "bender-build-tools": "static-1.3005",
  "inbound-db-properties-service-client": "static-1.3719",
  "superstore": "static-1.4621",
  "feedback-loader": "static-1.28968",
  "ai-components-ui-library": "static-1.8499",
  "ui-addon-video-player": "static-1.8548",
  "ui-coaching-tips": "static-1.28079",
  "sassPrefix": "static-1.152",
  "react-dnd-compat": "static-1.4472",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2345",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8016",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4503",
  "content-media-composition-data-lib": "static-1.11657",
  "content-media-compositions": "static-2.15664",
  "idb-keyval": "static-1.40",
  "immer": "static-1.33",
  "immerable": "static-1.4006",
  "magpie-lib": "static-1.5446",
  "magpie-types": "static-1.4906",
  "media-bridge-lib": "static-1.18653",
  "video-data-lib": "static-1.34390",
  "commerce-products-lib": "static-1.8991",
  "crm-message-bus": "static-1.42517",
  "growth-data-modal": "static-1.5212",
  "hubspot-apollo-client": "static-1.4731",
  "onboarding-tours-client": "static-1.4553",
  "calling-global-api": "static-1.63873",
  "calling-internal-common": "static-1.31151",
  "calling-lifecycle-internal": "static-1.65255",
  "calling-lifecycle-messages": "static-1.57549",
  "conditional-properties-service-client": "static-1.3671",
  "crm-links": "static-1.6121",
  "customer-data-objects-ui-components": "static-1.12865",
  "customer-data-property-utils": "static-1.7932",
  "external-options-client-types": "static-1.4032",
  "file-manager-components": "static-1.23053",
  "framework-data-schema-resolvers": "static-1.6725",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.537",
  "inbound-db-meta-service-client": "static-1.3468",
  "inbounddb-objects-service-types": "static-1.4096",
  "meetings-icalendar-utils-lib": "static-1.484",
  "multi-currency-client-types": "static-1.3564",
  "object-builder-ui-client": "static-1.48166",
  "pipeline-validation-client-types": "static-1.3837",
  "property-value-citations": "static-1.1549",
  "pulse": "static-1.376",
  "smart-property-lib": "static-1.6133",
  "tiered-pricing": "static-1.910",
  "ui-addon-form-validation": "static-1.10845",
  "growth-onboarding-confetti": "static-1.2924",
  "growth-onboarding-next-action-utils": "static-1.1429",
  "navigation-components": "static-1.17439",
  "onboarding-tours-utils": "static-1.405",
  "ui-shepherd-tracker": "static-1.7379",
  "ui-universal-auth": "static-1.8773",
  "batch-promise": "static-1.1403",
  "navigation-messaging": "static-1.6766",
  "getting-started-shared-tasks-store": "static-1.17140",
  "hubspotter-http-shared-msw-handlers": "static-1.9594",
  "usage-tracker-session-replay": "static-1.4873",
  "audio-components": "static-1.5688",
  "FileManagerCore": "static-1.38552",
  "FileManagerImages": "static-1.36204",
  "video-components": "static-1.12735",
  "foundations-components-legacy": "static-1.652",
  "growth-monetization-service-types": "static-1.4352",
  "nav-client-types": "static-1.2210",
  "purchase-motions-api": "static-1.5563",
  "self-service-api": "static-1.10094",
  "signup-constants": "static-1.18514",
  "signup-ui-url-generator": "static-2.7886",
  "trials-service-types": "static-1.3753",
  "usage-tracker-public": "static-1.6998",
  "chatspot-core": "static-1.20544",
  "chirp-fetch": "static-1.1735",
  "ContentUtils": "static-1.67778",
  "copilot-toolkit": "static-1.10665",
  "growth-onboarding-feedback-components": "static-1.6433",
  "hls.js": "static-1.35",
  "reactive-lib": "static-1.577",
  "simple-logging-lib": "static-1.2902",
  "commerce-permissions": "static-1.615",
  "customer-data-tracking": "static-1.6734",
  "products-iframe-lib": "static-1.7466",
  "products-ui-components-shared-msw-handlers": "static-1.9978",
  "hubspot-apollo-cache": "static-1.190",
  "calling-error-reporting": "static-1.31157",
  "shared-worker-versioning": "static-1.10891",
  "calling-usage-tracker": "static-1.6393",
  "voice-sms-access-library": "static-1.394",
  "conversations-skeleton-state": "static-1.7100",
  "location-customization-utils-lib": "static-1.8725",
  "crm-pipelines-api-client-types": "static-1.4013",
  "framework-builder-read-service-client": "static-1.3881",
  "framework-data-schema-quick-fetch": "static-1.6630",
  "persist-promise": "static-1.3560",
  "directed-graph": "static-1.791",
  "event-emitter": "static-1.799",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5397",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9679",
  "fsm": "static-1.3582",
  "policy-lib": "static-1.6630",
  "react-tinymce": "static-1.54764",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9742",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53890",
  "tinymce-plugins": "static-1.57004",
  "tinymce-themes": "static-1.55860",
  "growth-onboarding-next-action-components": "static-1.1457",
  "user-context-client": "static-1.4477",
  "unified-auth-core-lib": "static-1.568",
  "amplitude-session-replay-browser": "static-1.56",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4383",
  "video-embed": "static-1.35224",
  "content-icons-ui": "static-1.2175",
  "social-insights-client-types": "static-1.21509",
  "eligibility-engine-service-types": "static-1.3034",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4661",
  "integrations-lib": "static-1.15586",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4135",
  "calling-orchestration-schema": "static-1.35171",
  "crm-record-cards-service-types": "static-1.3490",
  "highcharts": "static-8.100",
  "trellis-story-utils": "static-1.4372",
  "storybook-react": "static-1.29",
  "hub-http-contrib": "static-1.2895",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39975",
  "ui-addon-sales-email": "static-1.5066",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12138",
  "layout-dnd-utils": "static-1.11113",
  "react-codemirror": "static-1.10478",
  "ui-brand-identity-lib": "static-1.14251",
  "NamespacedHubStyle": "static-2.8944",
  "outpost": "static-1.4052",
  "flux-actions": "static-1.316",
  "integrations-error-boundary-lib": "static-1.13001",
  "integrations-tracking-lib": "static-1.5443",
  "native-integrations-shared-strings": "static-1.7639",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10226",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67853",
  "layout-data-lib": "static-1.9438",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2853",
  "advanced-menus-core": "static-1.14893",
  "advanced-menus-lib": "static-1.11862",
  "ExportDialog": "static-6.10240",
  "ui-memberships-settings-lib": "static-1.33585",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14892",
  "simple-menus-lib": "static-1.16409"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1798",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9529",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24870",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5445",
  "hs-test-utils": "/hs-test-utils/static-1.7858",
  "hub-http": "/hub-http/static-1.6070",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9596",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17742",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11295",
  "I18n": "/I18n/static-7.1586",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6322",
  "payment-link-components": "/payment-link-components/static-1.23073",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6802",
  "quartz-core": "/quartz-core/static-1.6021",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10063",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5222",
  "rich-text-lib": "/rich-text-lib/static-1.19559",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17734",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5433",
  "UIComponents": "/UIComponents/static-3.8242",
  "foundations-assets": "/foundations-assets/static-1.4694",
  "foundations-components": "/foundations-components/static-1.7627",
  "foundations-theming": "/foundations-theming/static-1.4263",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1979",
  "framer-motion": "/framer-motion/static-1.68",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.604",
  "quartz-config": "/quartz-config/static-1.580",
  "quartz-routing": "/quartz-routing/static-1.232",
  "quick-fetch": "/quick-fetch/static-1.3786",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16502",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7997",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.51",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4619",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9397",
  "usage-tracker": "/usage-tracker/static-1.7187",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5604",
  "usage-tracker-core": "/usage-tracker-core/static-1.7037",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3278",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3079",
  "quartz-webpack": "/quartz-webpack/static-1.3026",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "customer-data-objects": "/customer-data-objects/static-1.7503",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7777",
  "laboratory-lib": "/laboratory-lib/static-3.7011",
  "onboarding-scopes": "/onboarding-scopes/static-1.6315",
  "rpc-client-utils": "/rpc-client-utils/static-1.4493",
  "ui-addon-opt": "/ui-addon-opt/static-4.8235",
  "HeadJS": "/HeadJS/static-2.723",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2969",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3953",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7524",
  "cssUtils": "/cssUtils/static-1.751",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9676",
  "HubStyle": "/HubStyle/static-2.11603",
  "knowledge-content-types": "/knowledge-content-types/static-1.8410",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.477",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9739",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10996",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8885",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9998",
  "video-components-external": "/video-components-external/static-1.10732",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4178",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5801",
  "customer-data-properties": "/customer-data-properties/static-1.50935",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18022",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4938",
  "onboarding-tours": "/onboarding-tours/static-1.16339",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7937",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3520",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8899",
  "user-context": "/user-context/static-1.4952",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.808",
  "hubspotter-http": "/hubspotter-http/static-1.4526",
  "icons": "/icons/static-2.630",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.498",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.477",
  "quartz-head": "/quartz-head/static-1.467",
  "quartz-test": "/quartz-test/static-1.477",
  "quartz-tracking": "/quartz-tracking/static-1.181",
  "ui-fonts": "/ui-fonts/static-1.557",
  "usage-tracker-container": "/usage-tracker-container/static-1.7177",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9278",
  "data-token-picker": "/data-token-picker/static-1.16131",
  "FileManagerLib": "/FileManagerLib/static-1.38693",
  "property-translator": "/property-translator/static-1.5262",
  "atom": "/atom/static-1.4922",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5560",
  "salesImages": "/salesImages/static-1.521",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5110",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1111",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3896",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.1356",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2746",
  "foundations-theming-base": "/foundations-theming-base/static-1.3248",
  "stylex": "/stylex/static-1.28",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5601",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4326",
  "react-flip-move": "/react-flip-move/static-1.66",
  "bender-build-tools": "/bender-build-tools/static-1.3005",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3719",
  "superstore": "/superstore/static-1.4621",
  "feedback-loader": "/feedback-loader/static-1.28968",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8499",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8548",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28079",
  "sassPrefix": "/sassPrefix/static-1.152",
  "react-dnd-compat": "/react-dnd-compat/static-1.4472",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2345",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8016",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4503",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11657",
  "content-media-compositions": "/content-media-compositions/static-2.15664",
  "idb-keyval": "/idb-keyval/static-1.40",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4006",
  "magpie-lib": "/magpie-lib/static-1.5446",
  "magpie-types": "/magpie-types/static-1.4906",
  "media-bridge-lib": "/media-bridge-lib/static-1.18653",
  "video-data-lib": "/video-data-lib/static-1.34390",
  "commerce-products-lib": "/commerce-products-lib/static-1.8991",
  "crm-message-bus": "/crm-message-bus/static-1.42517",
  "growth-data-modal": "/growth-data-modal/static-1.5212",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4731",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4553",
  "calling-global-api": "/calling-global-api/static-1.63873",
  "calling-internal-common": "/calling-internal-common/static-1.31151",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65255",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57549",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3671",
  "crm-links": "/crm-links/static-1.6121",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12865",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7932",
  "external-options-client-types": "/external-options-client-types/static-1.4032",
  "file-manager-components": "/file-manager-components/static-1.23053",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6725",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.537",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3468",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4096",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.484",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3564",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48166",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3837",
  "property-value-citations": "/property-value-citations/static-1.1549",
  "pulse": "/pulse/static-1.376",
  "smart-property-lib": "/smart-property-lib/static-1.6133",
  "tiered-pricing": "/tiered-pricing/static-1.910",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10845",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2924",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1429",
  "navigation-components": "/navigation-components/static-1.17439",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.405",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7379",
  "ui-universal-auth": "/ui-universal-auth/static-1.8773",
  "batch-promise": "/batch-promise/static-1.1403",
  "navigation-messaging": "/navigation-messaging/static-1.6766",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17140",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9594",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4873",
  "audio-components": "/audio-components/static-1.5688",
  "FileManagerCore": "/FileManagerCore/static-1.38552",
  "FileManagerImages": "/FileManagerImages/static-1.36204",
  "video-components": "/video-components/static-1.12735",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.652",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4352",
  "nav-client-types": "/nav-client-types/static-1.2210",
  "purchase-motions-api": "/purchase-motions-api/static-1.5563",
  "self-service-api": "/self-service-api/static-1.10094",
  "signup-constants": "/signup-constants/static-1.18514",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7886",
  "trials-service-types": "/trials-service-types/static-1.3753",
  "usage-tracker-public": "/usage-tracker-public/static-1.6998",
  "chatspot-core": "/chatspot-core/static-1.20544",
  "chirp-fetch": "/chirp-fetch/static-1.1735",
  "ContentUtils": "/ContentUtils/static-1.67778",
  "copilot-toolkit": "/copilot-toolkit/static-1.10665",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6433",
  "hls.js": "/hls.js/static-1.35",
  "reactive-lib": "/reactive-lib/static-1.577",
  "simple-logging-lib": "/simple-logging-lib/static-1.2902",
  "commerce-permissions": "/commerce-permissions/static-1.615",
  "customer-data-tracking": "/customer-data-tracking/static-1.6734",
  "products-iframe-lib": "/products-iframe-lib/static-1.7466",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9978",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.190",
  "calling-error-reporting": "/calling-error-reporting/static-1.31157",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10891",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6393",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.394",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7100",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8725",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4013",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3881",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6630",
  "persist-promise": "/persist-promise/static-1.3560",
  "directed-graph": "/directed-graph/static-1.791",
  "event-emitter": "/event-emitter/static-1.799",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5397",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9679",
  "fsm": "/fsm/static-1.3582",
  "policy-lib": "/policy-lib/static-1.6630",
  "react-tinymce": "/react-tinymce/static-1.54764",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9742",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53890",
  "tinymce-plugins": "/tinymce-plugins/static-1.57004",
  "tinymce-themes": "/tinymce-themes/static-1.55860",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1457",
  "user-context-client": "/user-context-client/static-1.4477",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.568",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4383",
  "video-embed": "/video-embed/static-1.35224",
  "content-icons-ui": "/content-icons-ui/static-1.2175",
  "social-insights-client-types": "/social-insights-client-types/static-1.21509",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3034",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4661",
  "integrations-lib": "/integrations-lib/static-1.15586",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35171",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3490",
  "highcharts": "/highcharts/static-8.100",
  "trellis-story-utils": "/trellis-story-utils/static-1.4372",
  "storybook-react": "/storybook-react/static-1.29",
  "hub-http-contrib": "/hub-http-contrib/static-1.2895",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39975",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5066",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12138",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11113",
  "react-codemirror": "/react-codemirror/static-1.10478",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14251",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8944",
  "outpost": "/outpost/static-1.4052",
  "flux-actions": "/flux-actions/static-1.316",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13001",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5443",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7639",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10226",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67853",
  "layout-data-lib": "/layout-data-lib/static-1.9438",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2853",
  "advanced-menus-core": "/advanced-menus-core/static-1.14893",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11862",
  "ExportDialog": "/ExportDialog/static-6.10240",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33585",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14892",
  "simple-menus-lib": "/simple-menus-lib/static-1.16409"
}
};
